import { CommonModule } from '@angular/common';
import { DateTimePickerComponent } from './date-time-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputMaskModule } from '@ngneat/input-mask';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
// import { TableCellsModule } from '../table-cells/table-cells.module';
import { MatInputModule } from '@angular/material/input';
import { TimeSelectModule } from '../time-select/time-select.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DateTimePickerComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
    TranslateModule,
    // TableCellsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    InputMaskModule,
    TimeSelectModule,
    MatInputModule,
    MatButtonModule,
  ],
  exports: [DateTimePickerComponent],
})
export class DateTimePickerModule {}
